import React, { Component } from "react";
import { Container, Row, Col, Button, Navbar, NavbarBrand, Input } from "reactstrap"
import { withRouter, } from "react-router-dom";
import moment from 'moment'
import Modal from 'react-modal'
import Select from 'react-select'
import TimeAgo from 'react-timeago'
import spanishStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'

import {Tabs,Products,Inventory} from './Components.cajero'

const formatter = buildFormatter(spanishStrings)

const customStylesOption = { control: styles => ({ ...styles, backgroundColor: '#fff', width: '90%', margin: '0 auto', marginBottom: 20, }), }
const customStyles = { content: { top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)', width: '70%', height: '70%', } };


class CajeroPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      p_venta: '',
      p_kg: 1,
      selected: 'precio',
      arrayListProductos: [],
      arrayListCategorias: [],
      arrListVenta: [], //Listado de ventas
      date: moment().format('YYYY-MM-DD'),
      typeCheckOrder: 2, //1 -> compra, 2 -> venta, 3 -> merma
      cantidadRecibidaE: 0,
      cantidadRecibidaTD: 0,
      cantidadRecibidaTC: 0,
      fpago: 1,
      isCreatingOrder: false,
      mostrarMisVentas: false,
      isOpenAltaProductos: false,
      arrProd: {
        codigo: '',
        codigoSAT: '',
        nombre: '',
        type: '',
        categoria: '',
        costo: '',
        precio_compra: 0,
        precio_venta: 0,
        iva: 0,
      },
      arrProductosByTraspaso: [],
      arrTraspasosPendientes: [],
      arrTraspasosConfirmados: [],
      valSeach: '',
      viewTypeFrom: 'general', //or meta
      fecha_entrada_almacen: moment().format('YYYY-MM-DD'),
      serie_almacen: '',
      referencia_almacen: '',
      noDocEntradaAlmacen: 0,
      arrItemsAlmacen: [],
      precio_producto: '',
      activeTab: 'punto',
			tabs: [
			{ id : 'punto', name: 'Punto de venta' },
			// { id : 'producto', name: 'Productos' },
			{ id : 'inventario', name: 'Inventario' },
			],

      finit: moment().format('YYYY-MM-DD'),
      ffin: moment().format('YYYY-MM-DD'),
      arrCategorias: [],
      updateInventory: false,
    }

  }

  componentDidMount() {
    this.getRelationCostosByDate()
  }

  updateState(obj){
    this.setState(obj)
  }

  getStyleModal(opt) {
    if (opt === 'isOpenAltaProductos') {
      return { content: { top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)', width: '50%', height: '50%', } };
    }

    return { content: { top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)', width: '80%', height: '80%', } };
  }

  render() {
    const { arrayListCategorias, arrayListProductos, arrListVenta, isOpenAltaProductos, arrProd,tabs,activeTab,arrCategorias } = this.state
    const { renderView, contentItems, sectionItems, contentSubitems } = this.props.initState
    const { section, idItem } = sectionItems;
    const subitems = arrayListProductos.filter(e => e.categoria === idItem)


    // let arrCategoriasFilter = [], arrCitasFilter = [];
    // arrCategorias.map((t,e) => {
    //   if(t.id_categoria !== '60ae75a798d59') {
    //     arrCategoriasFilter.push(t)
    //   } else {
    //     arrCitasFilter.push(t)
    //   }
    // })

    return (
      <div style={{ backgroundColor: '#f7f3f2', color: '#fff', height: '100%' }}>
        {/* HADER PAGE */}

        {

          <Navbar light expand="md" sticky={'top'} className="headerPagePos" style={{display:'flex',justifyContent:'space-between'}}>
            
            <NavbarBrand href="#" className="headerNavBrand">
              <img alt={"Logo"} src="img/pos/home.png" className="headerPagePos__logo"
                onClick={(e) => { sectionItems.section = 'lista_productos'; this.setState({ sectionItems }); }} />
                &nbsp;&nbsp;P. Venta
            </NavbarBrand>

            <div style={{ width: '100%', textAlign: 'center', position: 'absolute', height: 80, left: -10, zIndex: '-1' }}>
              <img alt={"Logo"} src="img/pos/logom.png" className="headerPagePos__logo" style={{ position: 'absolute', margin: '0 auto', top: 10 }} />
            </div>

            <p
              onClick={() => {
                localStorage.removeItem('nutrisadett_app_s');
                window.location.reload()
              }}
              className="initialPage__headerText"
              style={{ lineHeight: '13px', textAlign: 'left', paddingLeft: '10px', fontSize: '.8rem', fontWeight: 'bold', cursor: 'pointer', alignSelf: 'right' }}>Cerrar sesión</p>
          </Navbar>

        }

        <Container fluid className="ws_container_tabs2 pl-0 pr-0">
          <Tabs data={tabs} activeTab={activeTab} updateState={this.updateState.bind(this)} />
        </Container>

        <Container fluid className="containerFluid">
          <Row>
            <Col xs="12">
              {
                /*
                (section!=='calculadora') ?
                <div style={{paddingTop:15,paddingBottom:15}}>
                  <input type="text" className="inputSearchPos" placeholder={'Buscar...'}/>
                </div> : null
                */
              }
            </Col>
            {
              (activeTab==='punto') ? 
              this.makeViewHome()
              : (activeTab==='productos') ?
              <Products />
              : (activeTab==='inventario') ?
              <Inventory arrCategorias={arrCategorias} state={this.state} updateState={this.updateState.bind(this)} />
              : null
            }
          </Row>
        </Container>

        { this.makeViewTypePay()}

        <Modal
          overlayClassName="Overlay__aplicaciones"
          isOpen={isOpenAltaProductos}
          onRequestClose={() => { this.setState({ isOpenAltaProductos: false }) }}
          style={this.getStyleModal('isOpenAltaProductos')}
          contentLabel="Registrar nuevo producto"
        >
          <div className="modalBody__operador">
            <h4 style={{ marginBottom: 20, textAlign: 'center', }}>Registrar un producto</h4>

            <div className={'modalsVentas__formAddProducto'}>
              <p>Código</p>
              <input type={'text'}
                placeholder={'Ingresa un código'}
                onChange={(event) => {
                  arrProd.codigo = event.target.value
                  this.setState({ arrProd, })
                }}
                value={arrProd.codigo}
              />
            </div>

            <div className={'modalsVentas__formAddProducto'}>
              <p>Código SAT</p>
              <input type={'text'}
                placeholder={'Ingresa un código de SAT'}
                onChange={(event) => {
                  arrProd.codigoSAT = event.target.value
                  this.setState({ arrProd, })
                }}
                value={arrProd.codigoSAT}
              />
            </div>

            <div className={'modalsVentas__formAddProducto'}>
              <p>Nombre del producto</p>
              <input type={'text'}
                placeholder={'Ingresa la descripción del producto'}
                onChange={(event) => {
                  arrProd.nombre = event.target.value
                  this.setState({ arrProd, })
                }}
                value={arrProd.nombre}
              />
            </div>

            <div className={'modalsVentas__formAddProducto'}>
              <p>Categoría del producto</p>
              <Select
                onChange={(item) => {
                  arrProd.type = item.type
                  arrProd.categoria = item.value
                  this.setState({ arrProd, })
                }}
                placeholder={'Haz click para buscar un producto'}
                options={this.state.arrayListCategorias}
                styles={customStylesOption}
              />
            </div>

            <div className={'modalsVentas__formAddProducto'}>
              <p>¿Este producto tiene IVA?</p>
              <p
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  arrProd.iva = !arrProd.iva
                  this.setState({ arrProd, })
                }}
              >{arrProd.iva == 1 ? 'Si' : 'No'}</p>
            </div>

            <div className={'modalsVentas__formAddProducto'}>
              <p>Precio de compra</p>
              <input type={'text'}
                placeholder={''}
                onChange={(event) => {
                  arrProd.precio_compra = event.target.value
                  this.setState({ arrProd, })
                }}
                value={arrProd.precio_compra}
              />
            </div>

            <div className={'modalsVentas__formAddProducto'}>
              <p>Precio de venta</p>
              <input type={'text'}
                placeholder={''}
                onChange={(event) => {
                  arrProd.precio_venta = event.target.value
                  this.setState({ arrProd, })
                }}
                value={arrProd.precio_venta}
              />
            </div>

            <div>
              <button
                className={'modalsVentas__btnAddProducto'}
                onClick={() => { this.onAddProducto() }}
              >Registrar producto</button>
            </div>

          </div>
        </Modal>
      </div>
    )
  }

  makeViewHome(){
    const { arrayListCategorias, arrayListProductos, arrListVenta, isOpenAltaProductos, arrProd,tabs,activeTab } = this.state
    const { renderView, contentItems, sectionItems, contentSubitems } = this.props.initState
    const { section, idItem } = sectionItems;
    const subitems = arrayListProductos.filter(e => e.categoria === idItem)

    return(
      <Col xs="12" className="productos">
        <Row>
          {
            (section === 'index') ?
              <>
                {
                  arrayListCategorias.map((item, index) => (
                    <Col xs="4" lg="2" className="box__container">
                      <div className="box__producto"
                        onClick={(e) => {
                          sectionItems.section = 'subitems';
                          sectionItems.idItem = item.nombre;
                          sectionItems.indexItem = index;
                          this.setState({ sectionItems })
                        }}
                      >
                        <h1>{item.nombre}</h1>
                        {/*<h2>${item.precio}</h2>*/}
                      </div>
                    </Col>
                  ))
                }
                {
                  arrListVenta.length > 0 ?
                    <Col xs="4" lg="2" className="box__container">
                      <div className="box__producto" style={{ backgroundColor: '#44bd32', }}
                        onClick={(e) => { sectionItems.section = 'lista_productos'; this.setState({ sectionItems }); }} >
                        <h1 style={{}}>Cobrar / pagar</h1>
                        {/*<h2>${item.precio}</h2>*/}
                      </div>
                    </Col> : null
                }
              </>
              : (section === 'subitems') ?
                (subitems.length == 0) ?
                  <Col xs="4" lg="2" className="box__container">
                    <div className="box__producto"
                      onClick={
                        (e) => {
                          sectionItems.section = 'index';
                          sectionItems.idItem = '';
                          this.setState({ sectionItems })
                        }
                      }
                    >
                      <img alt={"Logo"} src="img/pos/back.png" className="headerPagePos__back" />
                    </div>
                  </Col>
                  : subitems.map((item, indexSub) => (

                    (indexSub === 0) ?
                      <>
                        <Col xs="4" lg="2" className="box__container">
                          <div className="box__producto"
                            onClick={
                              (e) => {
                                sectionItems.section = 'index';
                                sectionItems.idItem = '';
                                this.setState({ sectionItems })
                              }
                            }
                          >
                            <img alt={"Logo"} src="img/pos/back.png" className="headerPagePos__back" />
                          </div>
                        </Col>
                        <Col xs="4" lg="2" className="box__container">
                          <div className="box__producto" onClick={(e) => {
                            sectionItems.section = 'calculadora'
                            // sectionItems.idItem = '';
                            sectionItems.indexSubItem = indexSub;
                            this.setState({ sectionItems, p_venta: item.precio_venta, p_kg: '', selected: 'kg' })
                          }}>
                            <h1>{item.only_nombre}</h1>
                            <h2>${item.precio_venta}</h2>
                          </div>
                        </Col>
                      </>
                      :
                      <Col xs="4" lg="2" className="box__container">
                        <div className="box__producto" onClick={(e) => {
                          sectionItems.section = 'calculadora'
                          // sectionItems.idItem = '';
                          sectionItems.indexSubItem = indexSub;
                          this.setState({ sectionItems, p_venta: item.precio_venta, selected: 'kg' })
                        }} >
                          <h1>{item.only_nombre}</h1>
                          <h2>${item.precio_venta}</h2>
                        </div>
                      </Col>

                  ))
                : section === 'lista_productos' ? this.makeViewProductosSelecteds()
                  : section === 'calculadora' ? this.makeViewCalculadora()
                    : <></>
          }
        </Row>
      </Col>
    )
  }

  onGoToPayment() {
    const { sectionItems } = this.props.initState
    let { arrListVenta } = this.state
    sectionItems.section = 'lista_productos';
    this.setState({ sectionItems });

    if (arrListVenta.length === 1) {
      if (arrListVenta[0].id_producto === 'bascula') {
        this.setState({ typeCheckOrder: 2 })
      }
    }

  }

  passToCalculadora(index) {
    const { sectionItems } = this.props.initState
    sectionItems.section = 'calculadora'
    sectionItems.idItem = '';
    sectionItems.indexItem = index;
    this.setState({ sectionItems })
  }

  makeViewTypePay() {
    const { sectionItems, } = this.props.initState
    const { section, } = sectionItems;
    let { isCreatingOrder, p_venta, p_kg, arrListVenta, typeCheckOrder, } = this.state

    if (section === 'lista_productos') {
      let cantidadTotal = 0,
        flag = -1
      arrListVenta.map((t, e) => {
        cantidadTotal += (t.precio * t.cantidad);
        if (t.cantidad === "")
          flag = e
      })

      if (isCreatingOrder)
        return <p>Espera...</p>

      return (
        <div className="navbar__bottom" onClick={() => { this.onSendPagar() }}>
          <Row>
            <Col xs="6" className="navbar__bottom__text1">
              <h3 style={{ paddingLeft: 20, fontSize: '1.4rem' }}>Productos</h3>
            </Col>
            <Col xs="6" className="navbar__bottom__price">
              <span style={{ paddingRight: 20, fontSize: '1.8rem' }}>{arrListVenta.length}</span>
            </Col>
            <Col xs="12">
              <div className="navbar__bottom__total" style={{ backgroundColor: "#a3a3a3", marginLeft: 20, marginRight: 20, borderRadius: '10px', padding: 10 }}>
                <Row>
                  <Col xs="6" className="navbar__bottom__text1"><span style={{ paddingLeft: 10, fontSize: '1.4rem', fontWeight: '600', }}>{typeCheckOrder === 1 ? 'PAGAR' : 'COBRAR'}</span></Col>
                  <Col sx="6" className="navbar__bottom__price"><span style={{ paddingRight: 10, fontSize: '1.4rem', fontWeight: '600', }}>${this.number_format((cantidadTotal), 2)}</span></Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      )
    } else if (section === 'calculadora') {
      return (
        <div className="navbar__bottom">
          <Row>
            <Col xs="12">
              <div className="navbar__bottom__total" style={{ backgroundColor: "#a3a3a3", marginLeft: 20, marginRight: 20, borderRadius: '10px', padding: 10, margin: 10 }}>
                <Row>
                  <Col xs="6" className="navbar__bottom__text1"><span style={{ paddingLeft: 10, fontSize: '1.4rem', fontWeight: '600', }}>Total</span></Col>
                  <Col sx="6" className="navbar__bottom__price"><span style={{ paddingRight: 10, fontSize: '1.4rem', fontWeight: '600', }}>${this.number_format((p_venta * p_kg), 2)}</span></Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      )
    }
  }

  onSendPagar() {
    const { signedIn, id_vendedor, id_sucursal, printerActive, } = this.props.initState
    let { arrListVenta, date, typeCheckOrder, cantidadRecibidaE, cantidadRecibidaTD, cantidadRecibidaTC, fpago, } = this.state

    let cantidadTotal = 0
    arrListVenta.map((t) => { cantidadTotal += (t.precio * t.cantidad) })

    let residualEfectivo = 0
    let cantidadCambio = ((parseFloat(cantidadRecibidaE == '' ? 0 : cantidadRecibidaE) + parseFloat(cantidadRecibidaTD == '' ? 0 : cantidadRecibidaTD) + parseFloat(cantidadRecibidaTC == '' ? 0 : cantidadRecibidaTC)) - cantidadTotal)

    const id_pago = this.uniqid()
    let data = {
      id_pago,
      date,
      arr: arrListVenta,
      id_vendedor,
      nombre_cajero: (signedIn.nombre + ' ' + signedIn.apellidos),
      prioridad: 1,
      printerActive,
      cantidadRecibidaEfectivoTotal: cantidadRecibidaE,
      cantidadRecibidaE: residualEfectivo, cantidadRecibidaTD, cantidadRecibidaTC,
      codigo_unico: this.getRandomString(5),
      cantidadCambio,
      typeCheckOrder,
    }

    this.setState({ arrListVenta: [], isCreatingOrder: true })
    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=setRegisterNewVenta", this.headersPOST({ ...data, }))
      .then(response0 => response0.json())
      .then((response0) => {

        // console.log(response0)
        this.props.initState.socket.emit("toDirector", { substrace: 'updateVentaPoS', pos: 'nutrisadett', signedIn, opt: 2, })
        // alert('Orden registrada con éxito.')
        var opcion = window.confirm("Orden realizada con éxito. ¿Deseas imprimir?");
        if (opcion == true) {
          window.location = `posprinter://Imprimir/${id_pago}`
          setTimeout(() => {
            window.location.reload()
          }, 1000)
        } else {
          window.location.reload()
        }
        // if(response0.status == 'ok') {
        // }
      }).catch((error) => {
      });

  }

  makeViewProductosSelecteds() {
    const { renderView, sectionItems, contentSubitems } = this.props.initState
    let { arrListVenta, arrayListProductos, typeCheckOrder, } = this.state

    return (
      <Col xs="12">
        <Row>
          <Col xs="4">
            <span
              style={{ cursor: 'pointer', backgroundColor: '#a3a3a3', padding: 10, borderRadius: 10, marginBottom: 20, }}
              onClick={() => {
                sectionItems.section = 'index';
                this.setState({ sectionItems });
              }}
            >Atrás</span>
          </Col>
          <Col>
            <Row className={'ws-header-lista-productos'}>
              <Col>
                <p
                  onClick={() => { this.setState({ typeCheckOrder: 1, }) }}
                  className={`ws-btn-switch ${typeCheckOrder === 1 ? 'switch-active' : ''}`}>ENTRADA DE PRODUCTO</p>
              </Col>
              <Col>
                <p
                  onClick={() => { this.setState({ typeCheckOrder: 2, }) }}
                  className={`ws-btn-switch ${typeCheckOrder === 2 ? 'switch-active' : ''}`}>VENTA</p>
              </Col>
              <Col>
                <p
                  onClick={() => { this.setState({ typeCheckOrder: 3, }) }}
                  className={`ws-btn-switch ${typeCheckOrder === 3 ? 'switch-active' : ''}`}>MERMA</p>
              </Col>
            </Row>
          </Col>
          <Col xs="12">
            <h1 style={{ marginBottom: 5, }}>Lista de Productos</h1>
          </Col>
        </Row>

        <Row>
          <Col><p>Producto</p></Col>
          <Col><p>Cantidad</p></Col>
          <Col><p>Precio unit.</p></Col>
          <Col><p>Total</p></Col>
          <Col><p>Opciones</p></Col>
        </Row>
        {
          arrListVenta.map((t, e) => (
            <Row className={'ws__list_products_venta'}>
              <Col><p>{t.only_nombre}</p></Col>
              <Col>
                <input
                  value={t.cantidad}
                  onChange={(eInput) => { this.onUpdateCantidad(t, e, eInput.target.value) }}
                  type={"text"}
                  placeholder={"Ingresa la cantidad..."}
                  style={{ background: '#fff', border: 0, width: '70%', borderRadius: 4, }}
                />
              </Col>
              <Col>
                {
                  t.canEditProduct ? (
                    <>
                      <input
                        value={t.precio}
                        onChange={(eInput) => { this.onUpdatePrecio(t, e, eInput.target.value) }}
                        type={"text"}
                        placeholder={"Ingresa el precio..."}
                        style={{ background: '#fff', border: 0, width: '70%', borderRadius: 4, }}
                      />
                      <p style={{ fontWeight: 800, margin: 0, fontSize: '.7rem', lineHeight: '12px', cursor: 'pointer', }} onClick={() => { this.onUpdateBuy(e, !t.applyOnlyBuy) }} >{
                        t.applyOnlyBuy ? 'Solo para esta venta' : 'Actualizar en inventario'
                      }</p>
                    </>
                  ) : (
                    <p style={{ color: '#463132', }}>${this.number_format(t.precio, 2)}</p>
                  )
                }
              </Col>
              <Col><p>${this.number_format((t.cantidad * t.precio), 2)}</p></Col>
              <Col>
                <Row>
                  <Col>
                    <p style={{ cursor: 'pointer', color: 'red', fontWeight: '800', textAlign: 'center', margin: 0, }}
                      onClick={() => { this.deleteItemProduct(e) }}>X</p>
                  </Col>
                  <Col>
                    <p style={{ cursor: 'pointer', color: '#777', fontWeight: '800', textAlign: 'center', margin: 0, }}
                      onClick={() => { this.onEditValuesProduct(e, !t.canEditProduct) }}>Editar</p>
                  </Col>
                </Row>
              </Col>
            </Row>
          ))
        }
      </Col>
    )
  }

  onUpdateCantidad(t, e, value) {
    let { arrListVenta } = this.state
    arrListVenta[e].cantidad = value
    this.setState({ arrListVenta })
  }

  onUpdateFolio(t, e, value) {
    let { arrListVenta } = this.state
    arrListVenta[e].folio = value
    this.setState({ arrListVenta })
  }

  onUpdatePrecio(t, e, value) {
    let { arrListVenta } = this.state
    arrListVenta[e].precio = value
    this.setState({ arrListVenta })
  }

  onUpdateBuy(e, t) {
    let { arrListVenta } = this.state
    arrListVenta[e].applyOnlyBuy = t
    this.setState({ arrListVenta })
  }

  onEditValuesProduct(e, t) {
    let { arrListVenta } = this.state
    arrListVenta[e].canEditProduct = t
    this.setState({ arrListVenta })
  }

  deleteItemProduct(e) {
    let { arrListVenta, } = this.state
    const { signedIn } = this.props.initState
    const arr = arrListVenta.filter(function (item, index) { return index !== e })

    this.setState({
      arrListVenta: arr,
      valSearch: '',
    })

    if (arr.length === 0) {
      // this.props.initState.socket.emit("toDirector", { substrace: 'updateVentaPoS', pos: 'nutrisadett', signedIn, opt: 0, })
    }
  }

  makeViewCalculadora() {
    const { renderView, sectionItems, contentSubitems } = this.props.initState
    const { section, idItem } = sectionItems;
    const { p_venta, p_kg, selected, mostrarMisVentas } = this.state

    return (
      <Col xs="12">
        <Row>
          <Col xs="12">

            <div style={{ marginTop: 25 }}>
              <span
                style={{ cursor: 'pointer', backgroundColor: '#a3a3a3', padding: 10, borderRadius: 10, marginBottom: 30, marginRight: 20 }}
                onClick={() => {
                  sectionItems.section = 'index';
                  this.setState({ sectionItems })
                }}>Atrás</span>
              {/* <p
                className={'altasModule__btnAction btnActionSmall'}
                onClick={() => { this.setState({ isOpenAltaProductos: true, }) }}
              >Registrar nuevo producto</p>
              <p
                className={'altasModule__btnAction btnActionSmall'}
                onClick={() => { this.setState({ mostrarMisVentas: !mostrarMisVentas }) }}
              >{mostrarMisVentas ? 'Ver mi almacen' : 'Registrar entrada al almacen'}</p> */}
            </div>

            {this.state.mostrarMisVentas ? this.makeViewAlmacen() : ''}
            <div className="box__calculadora">
              <div className="box__calculadora__control" onClick={() => { this.setState({ selected: 'precio' }) }}>
                <input disabled={true} value={p_venta} type={"number"} onChange={(event) => { this.setState({ p_venta: event.target.value }) }} className="inputCalculadora" id={'inputPrecio'} />
                <span className={`inputCalculadoraTag ${selected === 'precio' ? 'active' : ''}`}>Precio</span>
              </div>
              <div className="box__calculadora__control" onClick={() => { this.setState({ selected: 'kg' }) }}>
                <input disabled={true} value={p_kg} type={"number"} onChange={(event) => { this.setState({ p_kg: event.target.value }) }} className="inputCalculadora" id={'inputPrecio'} />
                <span className={`inputCalculadoraTag ${selected === 'kg' ? 'active' : ''}`}>Cantidad</span>
              </div>
              <Row className="mt-4">
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item" onClick={(e) => { this.onPushButtonCalc('C'); }}><button>C</button></div></Col>
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item" onClick={(e) => { this.onPushButtonCalc('+-'); }}><button>+-</button></div></Col>
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item" onClick={(e) => { this.onPushButtonCalc('%'); }}><button>%</button></div></Col>
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item" onClick={(e) => { this.onPushButtonCalc('/'); }}><button>/</button></div></Col>
                {/* Segunda linea */}
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item bg__light" onClick={(e) => { this.onPushButtonCalc('7'); }}><button>7</button></div></Col>
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item bg__light" onClick={(e) => { this.onPushButtonCalc('8'); }}><button>8</button></div></Col>
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item bg__light" onClick={(e) => { this.onPushButtonCalc('9'); }}><button>9</button></div></Col>
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item" onClick={(e) => { this.onPushButtonCalc('X'); }}><button>X</button></div></Col>
                {/* Tercera linea */}
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item bg__light" onClick={(e) => { this.onPushButtonCalc('4'); }}><button>4</button></div></Col>
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item bg__light" onClick={(e) => { this.onPushButtonCalc('5'); }}><button>5</button></div></Col>
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item bg__light" onClick={(e) => { this.onPushButtonCalc('6'); }}><button>6</button></div></Col>
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item" onClick={(e) => { this.onPushButtonCalc('-'); }}><button>-</button></div></Col>
                {/* Cuarta linea */}
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item bg__light" onClick={(e) => { this.onPushButtonCalc('1'); }}><button>1</button></div></Col>
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item bg__light" onClick={(e) => { this.onPushButtonCalc('2'); }}><button>2</button></div></Col>
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item bg__light" onClick={(e) => { this.onPushButtonCalc('3'); }}><button>3</button></div></Col>
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item" onClick={(e) => { this.onPushButtonCalc('+'); }}><button>+</button></div></Col>
                {/* Quinta linea */}
                <Col xs="6" className="box__calculadora__button"><div className="box__calculadora__item bg__light rect__button" onClick={(e) => { this.onPushButtonCalc('0'); }}><button>0</button></div></Col>
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item bg__light" onClick={(e) => { this.onPushButtonCalc('.'); }}><button>.</button></div></Col>
                <Col xs="3" className="box__calculadora__button"><div className="box__calculadora__item bg__coffee" onClick={(e) => { this.onPushButtonCalc('='); }}><button>=</button></div></Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Col>
    )
  }

  onPushButtonCalc(val) {
    const { renderView, sectionItems, contentSubitems } = this.props.initState
    const { section, idItem, indexItem, indexSubItem, } = sectionItems;
    let { p_venta, p_kg, selected, arrListVenta, arrayListProductos, } = this.state

    const subitems = arrayListProductos.filter(e => e.categoria === idItem)


    if (val === '+-' || val === '%' || val === '/' || val === 'X' || val === '-' || val === '+') {
      return false
    } else if (val === '=') {
      //Siguiente o total
      if (selected === 'precio') {
        //pasa a kg
        this.setState({ selected: 'kg' })
      } else if (selected === 'kg') {
        this.setState({ selected: 'total' })

        //Agregamos el nuevo valor
        const t = subitems[indexSubItem]
        let newItem = [{
          nombre: t.nombre,
          only_nombre: t.only_nombre,
          applyOnlyBuy: true,
          canEditProduct: false,
          folio: t.folio,
          cantidad: p_kg,
          precio: p_venta,
          update: t.update,
          id_producto: t.id_producto,
        }]
        arrListVenta = [...arrListVenta, ...newItem]

        this.setState({
          arrListVenta,
          p_venta: '',
          p_kg: '',
          selected: 'precio',
        })
        this.props.initsetState({
          sectionItems: { section: 'index', idItem: '', indexItem: -1 },
        })
      }
    } else if (selected === 'precio') {
      if (val === 'C')
        p_venta = ''
      else {
        if (val === '.' && p_venta.indexOf('.') !== -1) { }
        else {
          p_venta += val
        }
      }

      this.setState({ p_venta, })
    } else if (selected === 'kg') {
      if (val === 'C')
        p_kg = ''
      else {
        if (val === '.' && p_kg.indexOf('.') !== -1) { }
        else {
          p_kg += val
        }
      }
      this.setState({ p_kg, })
    }
  }

  getRelationCostosByDate() {
    const data = {
      fecha_init: this.state.finit,
      fecha_fin: this.state.ffin,
    }

    //Solicitamos siempre información actualizada.
    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=getRelationCostosByDate", this.headersPOST({ ...data, }))
      .then(response => response.json())
      .then((response) => {

        let { countTotal, countUpdate, arrayListProductos, arrayListCategorias, noDocEntradaAlmacen, arrayDespachadores, numVentaGlobal, url_facturacion } = response
        //Minificamos el listado de productos (util para entradas al almacen)

        // getListProductosByArr

        this.setState({
          arrayListResults: [],
          numVentaGlobal,
          countTotal,
          countUpdate,
          arrayListProductos,
          arrayListCategorias,
          noDocEntradaAlmacen,
          arrayDespachadores,
        })

    }).catch((error) => {})

    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=getStockAlmacen", this.headersPOST({
      ...data,
    }))
    .then(response => response.json())
    .then((response) => {

      let { productos, categorias, } = response
      this.setState({
        arrCategorias: categorias,
        arrStock: productos
      })

    }).catch((error) => {})
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return '' + (Math.round(n * k) / k)
        .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length + 1).join('0')
    }
    return s.join(dec)
  }

  uniqid() {
    var pr = '', en = false, result; this.seed = function (s, w) { s = parseInt(s, 10).toString(16); return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s; }; result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5); if (en) { result += (Math.random() * 10).toFixed(8).toString(); } return result;
  }

  getRandomString($length) {
    let $cadena = "";
    let $caracteres = "1234567890";
    let $max = $caracteres.length - 1;
    $cadena += $caracteres[this.mt_rand(0, $max - 1)];

    for (let $i = 0; $i < $length - 1; $i++)
      $cadena += $caracteres[this.mt_rand(0, $max)];
    return moment().format('YYMMDD') + '' + $cadena;
  }

  mt_rand(min, max) {
    const argc = arguments.length
    if (argc === 0) {
      min = 0
      max = 2147483647
    } else if (argc === 1) {
      throw new Error('Warning: mt_rand() expects exactly 2 parameters, 1 given')
    } else {
      min = parseInt(min, 10)
      max = parseInt(max, 10)
    }
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  /*************
**
** MODAL ALTA
**
************/


  onAddProducto() {
    const { arrProd } = this.state
    const { codigo, nombre, type, categoria, precio_venta, } = arrProd
    //Validar
    if (codigo.trim() == '' || nombre.trim() == '' || type == '') {
      alert('Por favor, rellena los campos del formulario.');
      return false
    }

    //Registrar en BD
    const data = {
      ...arrProd,
      id_sucursal: this.props.initState.id_sucursal,
      id_vendedor: this.props.initState.id_vendedor,
    }

    // alert('registrando...')
  }

  makeViewAlmacen() {
    const { fecha_entrada_almacen, serie_almacen, referencia_almacen, noDocEntradaAlmacen, } = this.state

    return (
      <div className="initialPage__wrapper" style={{ backgroundColor: 'transparent', }}>
        {/* Principal Container */}
        <Row style={{ width: '99%', margin: '0 auto' }}>
          <Col className={'z-depth-1'} style={{ background: '#fff', }}>

            <Row>
              <p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '400', marginBottom: 10, color: '#444', textAlign: 'center', width: '100%', }}>Entrada al almacen</p>
              <hr />
            </Row>

            <Row>
              <Col>
                <Row>
                  <Col>
                    <p className="regVentaPage__product" style={{ padding: 0, }}>Fecha</p>
                  </Col>
                  <Col xs={'7'}>
                    <input type={"date"}
                      value={fecha_entrada_almacen}
                      onChange={(event) => { this.props.subSetState({ fecha_entrada_almacen: event.target.value }) }}
                      style={{ background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                    />
                  </Col>
                </Row>

                <Row>
                  <p className="regVentaPage__product" style={{ padding: '0 15px', width: '100%', }}>Documento #{noDocEntradaAlmacen}</p>
                </Row>
              </Col>

              <Col>
                <Row>
                  <Col>
                    <p className="regVentaPage__product" style={{ padding: 0, }}>Serie</p>
                  </Col>
                  <Col xs={'7'}>
                    <input type={'text'}
                      placeholder={'Ingresa una serie'}
                      value={serie_almacen}
                      onChange={(event) => { this.props.subSetState({ serie_almacen: event.target.value }) }}
                      style={{ background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p className="regVentaPage__product" style={{ padding: 0, }}>Referencia</p>
                  </Col>
                  <Col xs={'7'}>
                    <input type={'text'}
                      placeholder={'Ingresa una referencia'}
                      value={referencia_almacen}
                      onChange={(event) => { this.props.subSetState({ referencia_almacen: event.target.value }) }}
                      style={{ background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <hr />

            <Row>
              <Col xs={'2'}>
                <b>Código</b>
              </Col>
              <Col xs={'3'}>
                <b>Nombre</b>
              </Col>
              <Col xs={'2'}>
                <b>Cantidad</b>
              </Col>
              <Col xs={'2'}>
                <b>Cortesia</b>
                <p>* La cantidad ingresada solo se contempla en stock</p>
              </Col>
              <Col xs={'2'}>
                <b>Costo</b>
              </Col>
              <Col xs={'2'}>
                <b>Total</b>
              </Col>
              <Col xs={'1'}>
                <b>Opciones</b>
              </Col>
            </Row>

            <hr />

            {this.makeItemsEntradasAlmacen()}

          </Col>

        </Row>

      </div>

    )
  }

  makeItemsEntradasAlmacen() {
    const { arrItemsAlmacen, arrayListProductos, } = this.state
    let cantidadTotal = 0
    arrItemsAlmacen.map((t) => { cantidadTotal += (t.costo * t.cantidad) })

    //Show item new
    return (

      <>
        {
          arrItemsAlmacen.map((t, e) => (
            <Row>
              <Col xs={'2'}>
                <b>{t.codigo}</b>
              </Col>
              <Col xs={'3'}>
                <b>{t.producto}</b>
              </Col>
              <Col xs={'2'}>
                <input
                  ref={input => {
                    this[`inputAlmacenNew${e}`] = input;
                  }}
                  type={'text'}
                  onChange={(event) => {
                    arrItemsAlmacen[e].cantidad = event.target.value;
                    this.props.subSetState({ arrItemsAlmacen });
                  }}
                  value={t.cantidad}
                  placeholder={'Ingresa la cantidad'}
                  style={{ background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                />
              </Col>
              <Col xs={'2'}>
                <input type={'text'}
                  onChange={(event) => {
                    arrItemsAlmacen[e].costo = event.target.value;
                    this.props.subSetState({ arrItemsAlmacen });
                  }}
                  value={t.costo}
                  placeholder={'Ingresa el costo'}
                  style={{ background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                />
              </Col>
              <Col xs={'2'}>
                <p> ${this.number_format((t.cantidad * t.costo), 2)} </p>
              </Col>
              <Col xs={'1'}>
                <p
                  style={{ cursor: 'pointer', color: 'red', fontWeight: '800', }}
                  onClick={() => {
                    const arr = arrItemsAlmacen.filter(function (item, index) { return index !== e })
                    this.props.subSetState({ arrItemsAlmacen: arr })
                  }}
                >X</p>
              </Col>
            </Row>
          ))
        }

        {
          arrItemsAlmacen.length > 0
            ? (
              <div>
                <p style={{ textAlign: 'right', }}>Total: ${this.number_format(cantidadTotal, 2)}</p>

                <p
                  className={'modalsVentas__btnAddProducto'}
                  onClick={() => { this.onRegisterEntradaAlmacen() }}
                >Registrar entrada</p>
              </div>
            ) : null
        }

        <hr />

        {
          arrayListProductos.length > 0 ? (
            <Row style={{ marginTop: 20, }}>
              <Col xs={'4'} style={{ cursor: 'pointer', }}
                onClick={() => { this.setBindProductos() }}
              >
                <p>Elige un producto para agregar a la lista</p>
              </Col>
              <Col xs={'6'}>
                <input
                  type="text"
                  id={'ws-input-search-code'}
                  autoComplete="off"
                  placeholder="Ingresa el código del producto..."
                  value={this.state.valSearchByFullCode}
                  onChange={(e) => { this.setState({ valSearchByFullCode: e.target.value }) }}
                  onKeyDown={this._handleKeyDown}
                  ref={(input) => { this.inputSearchByCode = input; }}
                  style={{ margin: '20px auto', marginTop: 0, width: '100%', background: '#f3f3f3', border: '1px solid #ccc', borderRadius: 4, }}
                />
              </Col>
            </Row>
          ) : null
        }

      </>
    )
  }



};

export default withRouter(CajeroPage)